<div class="financial-card mfp-white-box" [ngClass]="{'financial-card--force-desktop': forceDesktopStyle}">
  <div class="financial-card__header">
    <h2 class="financial-card__header-title">{{ title }}</h2>
    <ng-container *ngIf="type === 'chart' && text">
      <img
        mfpLazyImage
        class="financial-card__header-icon"
        lazySrc="assets/icons/info-alert.svg"
      />
      <div class="financial-card__info mfp-white-box">
        <p class="financial-card__info-text">{{ text }}</p>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="type === 'chart'; else nochart">
    <div class="financial-card__chart">
      <div class="chart__bottom-line"></div>
      <div
        class="chart__limit"
        [style.bottom.px]="bar1.height"
      >
        <div class="chart__limit-line" ></div>
        <h2 class="chart__limit-value">
          {{ percentage | percent }}
        </h2>
      </div>
      <mfp-chart-bar
        class="chart__bar-1"
        [amount]="bar1.amount"
        [currency]="bar1.currency"
        [height]="bar1.height"
        [x]="bar1.title"
      ></mfp-chart-bar>

      <mfp-chart-bar
        class="chart__bar-2"
        [amount]="bar2.amount"
        [currency]="bar2.currency"
        [height]="bar2.height"
        [x]="bar2.title"
        [style]="'light'"
      ></mfp-chart-bar>
    </div>
  </ng-container>

  <ng-template #nochart>
    <h2 class="financial-card__value">

      <ng-container *ngIf="type === 'amount'; else showPercentage">
        <mfp-amount-currency>
          <span amount>{{ amount| configCurrency }}</span>
          <sup currency>{{ currency }}</sup>
        </mfp-amount-currency>
      </ng-container>

      <ng-template #showPercentage>
        {{ percentage | percent }}
      </ng-template>

    </h2>
  </ng-template>

  <ng-container *ngIf="type === 'amount' || type === 'percentage'">
    <p class="financial-card__text">{{ text }}</p>
  </ng-container>
</div>
